<template>
  <div class="login-layout">
    <router-view class="view-container" />
  </div>
</template>

<script>
export default {
  name: "LoginLayout"
};
</script>
